<!--
파일 업로더
-->
<template>
    <div :class="classObject">
        <slot name="headerBar"
              :display-add-webcam-button="displayAddWebcamButton"
              :open-webcam-area="openWebcamArea"
              :display-add-phone-button="displayAddPhoneButton"
              :display-add-local-button="displayAddLocalButton"
              :display-add-url-button="displayAddUrlButton"
        >
            <div class="component-header uk-flex uk-flex-between uk-flex-bottom">
                <h5
                    class="uk-margin-remove"
                    :class="size === 'large' ? 'uk-text-large' : ''"
                >
                    <slot name="header">
                        <i class="material-icons uk-text-middle">
                            attachment
                        </i>
                        <span class="uk-text-middle">{{ headerText }}</span>
                    </slot>

                </h5>

                <div>
                    <!-- 웹캠 촬영 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-black"
                        :class="headerButtonClass"
                        v-show="displayAddWebcamButton"
                        @click="startWebcam"
                        title="웹캠 이미지 촬영"
                    >
                        <i class="material-icons">camera</i>
                        WEBCAM
                    </button>
                    <!-- 웹캠 촬영 종료 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-danger"
                        :class="headerButtonClass"
                        v-show="openWebcamArea"
                        @click="endWebcam"
                        title="웹캠 촬영 종료"
                    >
                        <i class="material-icons">close</i>
                        CLOSE WEBCAM
                    </button>

                    <!-- 스마트폰 촬영 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-black"
                        :class="headerButtonClass"
                        v-show="displayAddPhoneButton"
                        @click="startPhotoSession"
                        title="스마트폰으로 이미지 촬영"
                    >
                        <i class="material-icons">smartphone</i>
                        PHONE
                    </button>

                    <!-- 파일추가 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-black"
                        :class="headerButtonClass"
                        v-show="displayAddLocalButton"
                        @click="startAddLocal"
                        title="PC에서 업로드"
                    >
                        <span uk-icon="icon: plus-circle"></span>
                        ADD FILE
                    </button>

                    <!-- URL추가 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-black"
                        :class="headerButtonClass"
                        v-show="displayAddUrlButton"
                        @click="startAddUrl"
                        title="ADD IMAGE BY URL"
                    >
                        <span uk-icon="icon: plus-circle"></span>
                        ADD URL
                    </button>


                    <!-- 세팅버튼 -->
                    <a class="uk-link-reset" @click="openSettingModal">
                        <i class="material-icons md-36">settings</i>
                    </a>


                </div>
            </div>
        </slot>

        <!-- 세팅 -->
        <setting
            ref="setting"
            class="uk-margin-left"

            :session-owner="sessionOwner"
            :default-settings="defaultSettings"
            @changed="settings => listenChangedSetting(settings)"
        >
        </setting>



        <div class="area uk-margin-left uk-flex uk-flex-between uk-flex-top uk-flex-wrap">
            <!-- 스마트폰 촬영중 -->
            <div v-show="openedPhotoSession" class="opened-session uk-margin-right">
                <div class="session-code">
                    code : {{ sessionCode }}
                </div>
                <div class="title-msg">
                    LINKED WITH PHONE
                </div>
                <div class="sub-msg">
                    Go to  [TAKE A PHOTO] menu by phone
                </div>





                <!-- 스마트폰 촬영 종료 버튼 -->
                <button 
                    type="button" 
                    class="uk-button uk-button-danger uk-button-large"
                    @click="endPhotoSession"
                    title="촬영을 종료합니다"
                >                
                    <span uk-icon="icon: close"></span>
                    unlink with PHONE
                </button>
                <div class="uk-text-center uk-text-meta">
                    촬영 종료후 [UNLINK WITH PHONE] 클릭
                </div>

                
            </div>

            <!-- URL로 추가영역 -->
            <div v-show="openAddUrlArea" class="add-url-area uk-margin-right">


                <div class="uk-flex uk-flex-between uk-flex-bottom">
                    <div class="uk-text-bold">
                        ADD IMAGE BY URL
                    </div>

                    <button
                        type="button"
                        class="uk-button uk-button-xsmall uk-button-danger"
                        v-show="openAddUrlArea"
                        @click="openAddUrlArea = false"
                        title="Close, ADD IMAGE URL"
                    >
                        <i class="material-icons">close</i>
                        close
                    </button>
                </div>

                <input type="text" class="uk-input" v-model="inputUrl" />
                <button
                    type="button"
                    class="uk-button uk-button-small uk-button-primary uk-width-full"
                    @click="addUrl"
                >
                    <i class="material-icons">check</i>
                    ADD URL
                </button>



            </div>




            <!-- 웹캠촬영 영역 -->
            <div v-show="openWebcamArea" class="upload-area uk-margin-right">


                <!-- 웹캠촬영 모달 -->
                <div ref="modalWebcam" class="uk-flex-top" uk-modal="stack: true" esc-close="false" bg-close="false">
                    <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-7-8" style="height: 90%">

                        <div class="uk-height-1-1 uk-flex uk-flex-between">
                            <!-- 촬영 부 -->
                            <div class="webcam-screen uk-width-expand">
                                <video ref="video">Video stream not available.</video>

                                <canvas ref="canvas"> </canvas>
                            </div>

                            <!-- 컨트롤러 부 -->
                            <div class="webcam-controller uk-width-medium uk-flex uk-flex-between uk-flex-column">
                                <div class="uk-text-center">
                                    <button
                                        class="uk-button uk-button-large2 uk-button-primary btn-take"
                                        @click="takeWebcam"
                                    >
                                        <i class="material-icons">photo_camera</i>
                                        촬영하기
                                    </button>
                                </div>

                                <div class="uk-padding-small">
                                    <div class="uploaded-images" ref="webcamUploadedImages">
                                        <img
                                            v-for="(dataurl, index) in webcamUploadedDataurls"
                                            :key="index"
                                            :src="dataurl"
                                        />

                                        <div v-show="webcamIsUploading" class="uploading">
                                            <div class="loading">
                                                <loading-icon
                                                    class="uk-text-middle uk-margin-top uk-margin-bottom"
                                                    bg-color="#fff"
                                                    fore-color="#333"
                                                ></loading-icon>
                                            </div>
                                            <div class="">
                                                Uploading...
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="uk-width-expand">


                                </div>

                                <div class="uk-text-center">
                                    <button class="btn-close uk-button uk-button-large2 uk-button-gray" @click="endWebcam">
                                        <i class="material-icons">close</i>
                                        닫기
                                    </button>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- 업로드 영역 -->
            <div v-show="openUploadArea" class="upload-area uk-margin-right">
                <!-- S3 업로드영역 (로컬업로드) -->
                <div v-show="openS3Upload" class="uk-margin-right">
                    <input type="file" class="s3-file-input" ref="s3-file-input" @change="onS3FileInputChange" multiple />

                    <!-- 업로드 안내 메세지 -->
                    <div class="s3-upload-clickable" @dragenter="s3Uploading = true" @dragleave="s3Uploading = false" @dragover.prevent @drop.prevent="onS3DndDrop" @click="onS3DndClick">
                        <i class="material-icons uk-text-middle">
                            cloud_upload
                        </i><br />
                        Drop files here or<br/>
                        Click to upload <br />
                        (US SERVER)

                        <div class="s3-dnd-msg uk-flex uk-flex-column uk-flex-center uk-flex-wrap-middle" :class="s3Uploading ? 'dragged' : null">
                            <loading-icon
                                class="uk-text-middle uk-margin-top uk-margin-bottom"
                                bg-color="#fff"
                                fore-color="#333"
                            ></loading-icon>
                            <div class="uk-text-large">
                                uploading...
                            </div>

                        </div>

                    </div>


                </div>


                <!-- 로컬 업로드영역 -->
                <div v-show="openLocalUpload">
                    <form action="/files" :id="formId" >
                        <input type="hidden" name="_token" :value="csrfToken"/>
                        <input type="hidden" name="type" :value="type"/>
                        <input v-if="tempId" type="hidden" name="temp_id" :value="tempId"/>
                        <input v-if="cmId" type="hidden" name="cm_id" :value="cmId"/>
                        <input v-if="prodId" type="hidden" name="prod_id" :value="prodId"/>
                        <input v-if="userId" type="hidden" name="user_id" :value="userId"/>
                        <input v-if="returnId" type="hidden" name="return_id" :value="returnId"/>


                        <!-- javascript 미지원시 fallback 처리 -->
                        <div class="fallback">
                            <input name="file" type="file" multiple />
                        </div>

                        <!-- 업로드 안내 메세지 -->
                        <div class="dz-message needsclick">
                            <i class="material-icons uk-text-middle">
                                cloud_upload
                            </i><br />
                            Drop files here or<br/>
                            Click to upload.
                        </div>
                    </form>
                </div>


                <div class="uk-text-center">
                    <!-- 드랍존 영역 닫기 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-small uk-button-danger"
                        v-show="openUploadArea"
                        @click="openUploadArea = false"
                        title="Close, ADD FILE"
                    >
                        <i class="material-icons">close</i>
                        close
                    </button>
                </div>
            </div>




            <div class="uploaded-area">
                <!-- 리스트 갱신 버튼 -->
                <div v-show="openedPhotoSession">
                    <button
                        type="button"
                        class="uk-button uk-button-white"
                        :class="size === 'large' ? 'uk-button-large' : 'uk-button-small'"
                        @click="refreshList(null)"
                        title="촬영한 파일목록 갱신"
                    >
                        <span uk-icon="icon: refresh"></span>
                        REFRESH LIST
                    </button>
                    <span class="uk-text-meta">
                    스마트폰으로 촬영하면, 3~5초 후에 자동으로 사진이 표시됩니다
                </span>
                </div>


                <!-- 업로드된 파일 리스트 -->
                <div v-show="items.length > 0" class="uploaded-items uk-flex uk-flex-left uk-flex-wrap">
                    <div v-for="item in items" :key="item.id" class="uploaded-item">
                        <!-- 썸네일 -->
                        <div class="thumb">
                            <!-- 이미지 -->
                            <img
                                v-if="item.is_img === 1"
                                :src="item.url"
                                class="img-file"
                            />

                            <!-- 기타파일 -->
                            <i v-if="item.is_img !== 1" class="material-icons etc-file">
                                attach_file
                            </i>
                        </div>

                        <!-- 파일정보 -->
                        <div class="file-info">
                            <div class="size" :title="item.size">
                                {{ item.size }}
                            </div>
                            <div class="uploaded_by" :title="item.uploaded_by_nick">
                                by {{ item.uploaded_by_nick }}
                            </div>
                            <div class="created_at" :title="item.created_at">
                                at {{ item.created_at }}
                            </div>
                        </div>

                        <!-- 파일명 -->
                        <div class="file-name" :title="item.name">
                            {{ item.name }}
                        </div>


                        <!-- 삭제 버튼 -->
                        <a class="remove-btn" @click="removeUploadedFile(item)" title="click to remove">
                            <i class="material-icons">remove_circle_outline</i>
                        </a>

                        <!-- 바로보기 버튼 -->
                        <a
                            class="view-btn"
                            :href="item.url"
                            title="click to view"
                            target="_blank"
                        >
                            <i class="material-icons">pageview</i>
                        </a>

                        <!-- 다운 버튼 -->
                        <a
                            class="down-btn"
                            :href="item.download_url"
                            title="click to download"
                            @click.prevent="download(item)"
                        >
                            <i class="material-icons">cloud_download</i>
                        </a>

                    </div>
                </div>
            </div>

        </div>
        
        
    </div>

</template>

<script>
    import LoadingIcon from "../common/loading-icon";
    // dropzone
    import * as Dropzone from '../../../../dropzone/dist/dropzone-amd-module.js';
    import moment from "moment";
    Dropzone.autoDiscover = false;


    // 세션정보 갱신시간
    let session_refresh_timeout = 3000;

    // vue component
    export default {
        components: {
            LoadingIcon,
            'setting': require('./setting.vue').default,
        },
        props: {
            /**
             * 라라벨 csrf 토큰
             */
            csrfToken: {
                type: String,
                default: null
            },
            /**
             * 파일종류
             */
            type: {
                type: Number,
                default: null
            },
            /**
             * 커뮤니케이션 ID
             */
            cmId: {
                type: Number,
                default: null
            },
            /**
             * 상품ID
             */
            prodId: {
                type: Number,
                default: null
            },
            /**
             * 사용자ID
             */
            userId: {
                type: Number,
                default: null
            },
            /**
             * 반품ID
             */
            returnId: {
                type: Number,
                default: null
            },
            /**
             * 최초에 업로드영역을 펼친채로 표시할지 여부
             */
            initOpenUploadArea: {
                type: Boolean,
                default: false
            },
            /**
             * 촬영세션 용 현재 사용자 ID
             */
            sessionOwner: {
                type: Number,
                default: null
            },
            /**
             * 컴포넌트 헤더
             */
            headerText: {
                type: String,
                default: 'ATTACHMENTS (첨부파일)'
            },
            /**
             * 컴포넌트 사이즈 (small / large)
             *  - 버튼 및 텍스트
             */
            size: {
                type: String,
                default: 'small'
            },


            /**
             * 웹캠 버튼 감춤
             */
            hideAddWebcamButton: {
                type: Boolean,
                default: false,
            },

            /**
             * 스마트폰촬영 버튼 감춤
             */
            hideAddPhoneButton: {
                type: Boolean,
                default: false,
            },
            /**
             * 로컬파일 버튼 감춤
             */
            hideAddLocalButton: {
                type: Boolean,
                default: false,
            },
            /**
             * URL 버튼 감춤
             */
            hideAddUrlButton: {
                type: Boolean,
                default: false,
            },

            /**
             * 영역 수직 레이아웃(작은 화면에서 사용)
             *  - false : 수평 레이아웃으로 표시됨
             */
            verticalLayout: {
                type: Boolean,
                default: false,
            },

            /**
             * 업로드서버 Code\System\UploadServer
             */
            uploadServer: {
                type: String,
                default: 's3-us',
            },

            /**
             * 세팅 기본값(로컬스토리지에 설정된값이 없을경우 적용될 세팅)
             * 기본설정되야하는 일부 항목만 설정가능
             */
            defaultSettings: {
                type: Object,
                default: () => {
                    return {};
                },
            },

        },
        data: function () {
            return {
                /**
                 * 업로드가 완료된 파일 배열
                 * [
                 *      {}, 서버에서 받아온 업로드된 파일정보
                 *      .
                 *      .
                 *      .
                 *      {
                 *          App\Http\Controllers\Web\Files\Store 참고
                 *      }
                 * ]
                 */
                items: [],

                // 웹캠촬영영역 open 여부
                openWebcamArea: false,

                // 업로드영역 open 여부
                openUploadArea: this.initOpenUploadArea,

                // URL추가영역 open 여부
                openAddUrlArea: false,



                // 세션연결중 여부
                openedPhotoSession: false,

                // 세션객체
                session: null,

                // 임시파일ID
                tempId: null,

                // (int) 저장소종류 (1: 로컬, 2: s3, 9: 외부url)
                //storage: 1,

                // (string) url 입력값
                inputUrl: null,

                // AWS 라이브러리 s3객체
                s3: null,
                s3Region: 'us-east-1',
                s3PoolId: 'us-east-1:4230e52f-a048-4d4d-80ea-c6dc31823eb9',
                s3Bucket: 'gonelo-img-us',

                // s3 업로드딩중
                s3Uploading: false,

                // s3 업로드 루트디렉토리 (ap, demo, local)
                s3Basedir: 'local',

                // 로컬스토리지 세팅정보
                settings: {},

                /**
                 * 웹캠관련 정보
                 */
                webcam: {
                    width: null,
                    height: null,
                    streaming: false,
                },

                /**
                 * (array)
                 * 웹캠 업로드한 이미지 dataurl 배열
                 */
                webcamUploadedDataurls: [],

                /**
                 * (bool)
                 * 웹캠 업로드중 여부
                 */
                webcamIsUploading: false,

            };
        },
        computed: {

            /**
             * 웹캠 버튼 노출여부
             */
            displayAddWebcamButton() {
                // 설정 우선적용
                if (! this.settings.onAddWebcam) {
                    return false;
                }

                return this.hideAddWebcamButton === false
                    && this.openWebcamArea === false;
            },

            /**
             * 스마트폰촬영 버튼 노출여부
             */
            displayAddPhoneButton() {
                // 설정 우선적용
                if (! this.settings.onAddPhone) {
                    return false;
                }

                return this.hideAddPhoneButton === false
                    && this.openedPhotoSession === false;
            },

            /**
             * 파일추가(로컬업로드) 버튼 노출여부
             */
            displayAddLocalButton() {
                // 설정 우선적용
                if (! this.settings.onAddLocal) {
                    return false;
                }

                return this.hideAddLocalButton === false
                    && this.openUploadArea === false;
            },

            /**
             * URL추가 버튼 노출여부
             */
            displayAddUrlButton() {
                // 설정 우선적용
                if (! this.settings.onAddUrl) {
                    return false;
                }

                return this.hideAddUrlButton === false
                    && this.openAddUrlArea === false;
            },

            // S3업로드 영역 open 여부
            openS3Upload: function () {
                switch (this.uploadServer) {
                    case 's3-us':
                        return true;
                        break;
                }
                return false;
            },

            // 로컬(웹서버)업로드 영역 open 여부
            openLocalUpload: function () {
                return this.uploadServer === 'local';
            },




            formId: function () {
                return this.get_cmp_id();
            },

            sessionCode: function () {
                return this.session ? this.session.session_code : null;
            },

            /**
             * 헤더부분에 있는 버튼들 class
             *  - [phone]
             *  - [add file]
             *  @return Object
             */
            headerButtonClass()
            {
                return {
                    // 사이즈
                    'uk-button-large': this.size === 'large',
                    'uk-button-small': this.size !== 'large',
                };
            },

            /**
             * 컴포넌트 전체에 대한 css 클래스
             *  @return Object
             */
            classObject()
            {
                return {
                    // 수직 레이아웃
                    'vertical-layout': this.verticalLayout,
                };
            },
        },
        watch: {
            /**
             * 아이템이 변경되면 이벤트 발생
             */
            items: function () {
                let ids = _.map(this.items, 'id');
                this.$emit('update:ids', ids);
                //console.log(ids);
            }
        },
        mounted: function () {
            let cmp = this;

            // Dropzone 생성
            this.myDropzone = new Dropzone("#"+this.formId, {
                maxFilesize: 10, // MB
                timeout: 90000, // 1분 30초, 밀리세컨드기준
            });
            //console.log(myDropzone);
            document.querySelector("#"+this.formId).classList.add("dropzone");

            // dropzone 이벤트 리스닝
            let myDropzone = this.myDropzone;
            /*
            myDropzone.on("addedfile", function(file) {
                console.log('added file!');
                console.log(file);
                return;
            });
            */


            myDropzone.on("success", function(file, response) {
                //console.log('success');
                // 배열에 추가
                cmp.items.push(response.uploaded);

                // dropzone 업로드 영역에서 제거
                myDropzone.removeFile(file);
            });
            myDropzone.on("sending", function(file, xhr, formData) {
                //Execute on case of timeout only
                xhr.ontimeout = function(e) {
                    //Output timeout error message here
                    //console.log('Server Timeout');
                    //file.previewTemplate.appendChild($('<div style="position: absolute; top:0; left: 0; color: #fff; background-color: red">Server Timeout</div>'));
                    let bg = document.createElement('div');
                    bg.style.cssText = 'position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 120px; padding: 1rem; color: #fff; background-color: #ff3300; z-index: 2000;';

                    let title = document.createElement('div');
                    title.style.cssText = 'font-size: 1.5rem; text-align: center;';
                    title.innerText = 'TIME OUT';

                    let desc = document.createElement('div');
                    desc.style.cssText = 'font-size: 1rem; text-align: center;';
                    desc.innerText = '일시적으로 네트워크가 불안정합니다. 새로고침 후 다시 시도하세요.';

                    file.previewTemplate.appendChild(bg);
                    bg.appendChild(title);
                    bg.appendChild(desc);
                    //console.log(file.previewTemplate);

                };
            });

            // 초기화 작업
            this.init();

            
        },
        methods: {
            /**
             * 세팅 모달 열기
             */
            openSettingModal() {
                this.$refs.setting.openSettingModal();
            },

            /**
             * 파일 다운로드처리
             */
            download(item) {
                //console.log(item);
                let xhr = new XMLHttpRequest();
                xhr.onreadystatechange = function() {
                    if (this.readyState == 4 && this.status == 200){

                        let filename = item.name;
                        /*
                        var disposition = xhr.getResponseHeader('Content-Disposition');
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            var matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                        }
                         */

                        // 확장자 없는데, mime 이 image 인 것
                        if (filename.indexOf('.') === -1 && this.response.type === 'image') {
                            // console.log('only image');
                            filename += '.jpg';
                            //filename += '.webp';
                        }

                        //this.response is what you're looking for
                        //console.log(this.response, typeof this.response);
                        let a = document.createElement("a");
                        let url = URL.createObjectURL(this.response)
                        a.href = url;
                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                    }
                }
                xhr.open('get', item.download_url);
                xhr.responseType = 'blob'; // !!필수!!
                xhr.send({});
            },

            /**
             * S3 파일업로드 관련 이벤트들
             */
            onS3DndClick () {
                this.$refs['s3-file-input'].click();
            },
            onS3DndDrop (e) {
                const files = e.dataTransfer.files
                this.s3Upload(files);
            },
            onS3FileInputChange (e) {
                const files = e.target.files;
                this.s3Upload(files);
            },


            /**
             * S3로 업로드함.(프라미스 반환)
             * @param files
             * @returns {Promise<ManagedUpload.SendData>|*}
             */
            s3Upload(files) {

                if (!files.length) {
                    return alert("Please choose a file to upload first.");
                }

                this.s3Uploading = true;

                for (let i = 0; i < files.length; i++) {
                    let file = files[i];

                    // 같은파일명인경우 덮어씀. 파일명에 시분초마이크로 붙여서 구분함
                    let fileName = moment().format('HHmmssSSS') + file.name;
                    let albumPhotosKey = encodeURIComponent(this.s3Basedir)
                        + '/' + moment().format('YYYY')
                        + '/' +  moment().format('MMDD')
                        + '/';

                    let photoKey = albumPhotosKey + fileName;

                    // Use S3 ManagedUpload class as it supports multipart uploads
                    let upload = new AWS.S3.ManagedUpload({
                        params: {
                            Bucket: this.s3Bucket,
                            Key: photoKey,
                            Body: file,
                            ContentType: file.type,
                        }
                    });
                    //console.log(file.type);

                    /**
                     * todo : 멀티파일업로드시, 1개씩 순차적으로 실행되도록 처리안함
                     * AWS에서 잘 처리하는 것 같아서 둠.
                     * 나중에 이슈있으면 순차처리되도록 프라미스처리부분 수정하면됨.
                     */
                    let promise = upload.promise();
                    const cmp = this;
                    promise.then(
                        function(data) {
                            console.log("Successfully uploaded photo.");
                            //console.log('s3upload promise then!');
//                            console.log(data);

                            let uploaded = {
                                s3_region: cmp.s3Region,
                                s3_bucket: data.Bucket,
                                s3_key: data.Key,
                                url: data.Location,
                                mime: file.type,
                                bytes: file.size,
                                name: file.name,
                            };
                            cmp.insertS3(uploaded);

                        }
                    ).catch((err) => {
                        return alert("There was an error uploading your photo");
                    }).finally(() => {
                        //console.log('s3upload promise finally!');
                        cmp.s3Uploading = false;
                    });

                    return promise;
                    //console.log('end promise' + i);
                }



            },



            /**
             * 초기화를 Promise 처리 후 실행해준다
             *  - upload 컴포넌트의 prodId 등의 값을 동적으로 할당해서 사용하는 경우에,
             *    refreshList() 실행이, prodId 등의 값 설정보다 먼저 실행되어,
             *    최초 리스트로드가 제대로 실행되지 않는 오류가 있어,
             *    모든 준비(리소스ID들이 업로드컴포넌트의 파라메터로 다 전달이 완료된 후)가 끝난 후 init을 실행
             *
             * @param init_ready_promise (Promise) 초기화준비에 대한 Promise
             */
            initPromise(init_ready_promise) {
                if (! init_ready_promise) {
                    init_ready_promise = new Promise((resolve, reject) => {
                        resolve();
                    });
                }

                init_ready_promise.then(() => {
                    this.init();
                });
            },

            /**
             * 초기화
             */
            init() {
                // AWS 세팅
                if (this.uploadServer !== 'local') {
                    AWS.config.update({
                        region: this.s3Region,
                        credentials: new AWS.CognitoIdentityCredentials({
                            IdentityPoolId: this.s3PoolId
                        })
                    });

                    this.s3 = new AWS.S3({
                        apiVersion: "2006-03-01",
                        params: { Bucket: this.s3Bucket }
                    });

                    // 루트디렉토리 결정
                    switch (window.location.hostname) {
                        case 'global.gonelo.com':
                        case 'gonelo.com':
                            this.s3Basedir = 'ap';
                            break;
                        case 'demo.global.gonelo.com':
                            this.s3Basedir = 'demo';
                            break;
                        default:
                            this.s3Basedir = 'local';
                            break;
                    }

                }



                // 주요변수 초기화
                this.items = [];
                this.openUploadArea = this.initOpenUploadArea;
                this.openAddUrlArea = false;
                this.openedPhotoSession = false;
                this.session = null;
                this.tempId = null;


                let temp_id_promise = null;
                if (this.type === 99) {
                    // 임시ID 조회 후 실행되는 Promise
                    temp_id_promise = this.loadTempId();
                } else {
                    temp_id_promise = new Promise((resolve, reject) => {
                        resolve();
                    });
                }

                // promise 처리
                temp_id_promise.then(() => {
                    // 리스트 로드
                    this.refreshList(null);

                    // 최초에 세션 읽어옴
                    this.loadSession();

                });
            },

            /**
             * 세팅 로드 이벤트수신
             * @param settings
             */
            listenChangedSetting(settings) {
                this.settings = settings;
            },

            /**
             * 임시ID 조회
             * @return Promise
             */
            loadTempId() {
                // promise 생성
                return new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/file-temp-id',
                        data: {
                            //'_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            this.tempId = response.temp_id;
                            // promise 성공
                            resolve(response);
                        },
                        error: (jqXHR, textStatus, errorThrown) => {
                            alert('초기화(임시ID조회 실패) 도중 문제가 발생했습니다. 새로고침 후 다시 시도하세요');
                            // promise 실패
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });

            },

            /**
             * 파일리스트 ajax load
             */
            refreshList: function (changed) {
                // 검색조건이 하나도 없으면 조회 시도하지 않음
                if (! (this.tempId || this.cmId || this.prodId || this.userId || this.returnId)) {
                    return;
                }

                let cmp = this;


                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/files',
                    data: {
                        'temp_id': cmp.tempId,
                        'cm_id': cmp.cmId,
                        'prod_id': cmp.prodId,
                        'user_id': cmp.userId,
                        'return_id': cmp.returnId,
                    },
                    success: function (res) {
                        // 초기화
                        cmp.items = [];

                        _.forEach(res.uploaded_files, function (uploaded) {
                            cmp.items.push(uploaded);
                        });

                        // 변경버전 기록
                        if (changed) {
                            console.log(changed);
                            cmp.curr_changed = changed;
                            if (cmp.openedPhotoSession) {
                                //3초뒤 재호출처리
                                setTimeout(cmp.loadSession, session_refresh_timeout);
                            }
                            
                        }                        

                    },
                };

                // ajax 실행
                $.app.ajax.module.background(opts);

                // 테스트 추가
                /*
                this.items.push({ 
                    id: 1, 
                    hashname: 'aaaaaaaaaaaaaaaa', 
                    name: "파일명.svg", 
                    bytes: 12345,
                    url: 'http://www.dropzonejs.com/images/new-logo.svg',
                    download_url: 'http://www.dropzonejs.com/images/new-logo.svg',
                    uploaded_by_nick: '업로더',
                    created_at: "2018-07-11 21:27:06",
                    is_img: 1,
                    size: '1.2Mb',
                });
                */
            },

            /**
             * 업로드된 파일을 삭제한다
             */
            removeUploadedFile: function (uploaded) {
                // 컨펌
                if (! confirm('Are you sure, remove the file?')) {
                    return;
                }

                // 프라미스처리로 한건씩 처리
                let promise = new Promise((resolve, reject) => resolve());

                // S3인경우 S3에서 먼저 삭제진행

                if (parseInt(uploaded.storage) === 2) {
                    promise = promise.then(() => {
                        return new Promise((resolve, reject) => {
                            this.s3.deleteObject({Key: uploaded.s3_key}, function (err, data) {
                                if (err) {
                                    reject(err.message);
                                    return;
                                }
                                console.log("Successfully deleted photo.");
                                resolve();
                            });
                        });
                    });

                }

                promise.then(() => {
                    // ajax로 업로드파일 삭제진행
                    let cmp = this;
                    let opts = {
                        type: 'delete',
                        url: '/files/'+uploaded.hashname,
                        data: {
                            '_token': this.csrfToken,
                        },

                        success: function (res) {

                            // 배열에서 제거
                            let index = _.findIndex(cmp.items, function (v) {
                                return v.id === uploaded.id;
                            });
                            cmp.items.splice(index, 1);

                        }
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                }).catch((msg) => {
                    if (msg) {
                        alert(msg);
                    }
                });


            },

            /**
             * URL 추가
             */
            addUrl: function () {
//                console.log(this.inputUrl);

                // ajax로 url 추가처리
                let cmp = this;
                let opts = {
                    type: 'post',
                    url: '/files',
                    data: {
                        _token: this.csrfToken,
                        type: this.type,
                        temp_id: this.tempId,
                        cm_id: this.cmId,
                        prod_id: this.prodId,
                        user_id: this.userId,
                        return_id: this.returnId,
                        storage: 9,
                        external_url: this.inputUrl,
                    },

                    success: function (res) {
                        //console.log(res);

                        // 배열에 추가
                        cmp.items.push(res.uploaded);

                        // 입력값 초기화
                        cmp.inputUrl = null;

                    }
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },

            /**
             * S3업로드 결과처리
             * @param uploaded 업로드정보
             */
            insertS3: function (uploaded) {
                //console.log(uploaded);

                // ajax
                let cmp = this;
                let opts = {
                    type: 'post',
                    url: '/files',
                    data: {
                        _token: this.csrfToken,
                        type: this.type,
                        temp_id: this.tempId,
                        cm_id: this.cmId,
                        prod_id: this.prodId,
                        user_id: this.userId,
                        return_id: this.returnId,
                        storage: 2,

                        external_url: uploaded.url,
                        mime: uploaded.mime,
                        bytes: uploaded.bytes,
                        name: uploaded.name,

                        s3_region: uploaded.s3_region,
                        s3_bucket: uploaded.s3_bucket,
                        s3_key: uploaded.s3_key,
                    },

                    success: function (res) {
                        //console.log(res);

                        // 배열에 추가
                        cmp.items.push(res.uploaded);

                    }
                };

                // ajax 실행
                $.app.ajax.module.background(opts);
            },

            /**
             * 촬영을 시작한다.
             */
            startPhotoSession: function () {

                // ajax로 세션생성
                let cmp = this;
                let opts = {
                    type: 'post',
                    url: '/photo-sessions',
                    data: {
                        '_token': this.csrfToken,
                        'type': cmp.type,
                        'temp_id': cmp.tempId,
                        'cm_id': cmp.cmId,
                        'prod_id': cmp.prodId,
                        'user_id': cmp.userId,
                        'return_id': cmp.returnId,
                    },

                    success: function (res) {
                        // 세션정보 갱신
                        cmp.loadSession();
                    }
                };

                // ajax 실행
                $.app.ajax.module.default(opts);     

            },

            /**
             * 촬영을 종료한다.
             */
            endPhotoSession: function () {
                // ajax로 세션종료
                let cmp = this;
                let opts = {
                    type: 'delete',
                    url: '/photo-sessions',
                    data: {
                        '_token': this.csrfToken,
                    },

                    success: function (res) {
                        cmp.openedPhotoSession = false;
                    }
                };

                // ajax 실행
                $.app.ajax.module.default(opts);  
            },

            /**
             * 세션정보를 얻어온다 (ajax 처리)
             * 
             * 주의 : uploader.vue, upload-on-phone.vue 동일하게 관리되는 메소드
             *       나중에 부모만들어서 상속처리해야함
             */
            loadSession: function () {
                let cmp = this;

                
                
                // ajax로 업로드파일 삭제진행
                let opts = {
                    type: 'get',
                    url: '/photo-sessions/my',

                    success: function (res) {
                        let response_session = res.session;
                        /**
                         * 응답온 세션이 현재 내 컴포넌트의 세션이 맞는지 검증
                         * - 검증하지 않으면, 동시에 두개 상품에서 컴포넌트 실행하면
                         *   같은 사용자의 세션이기때문에 두개 컴포넌트 모두 세션실행중으로 표시됨
                         */
                        if (response_session && cmp.validateSession(response_session) === false) {
                            response_session = null;
                        }
                        
                        // 세션정보 저장
                        cmp.session = response_session;
                        if (cmp.session) {
                            // 세션오픈으로 설정
                            cmp.openedPhotoSession = true;

                            // 최초 실행시, 변경버전 기록
                            if (! cmp.curr_changed) {
                                cmp.curr_changed = cmp.session.changed;
                            }
                        } else {
                            // 세션종료로 설정
                            cmp.openedPhotoSession = false;
                        }

                        // 세션이 살아있으면
                        if (cmp.openedPhotoSession) {
                            // 정보가 변경되었는지 비교
                            if (cmp.curr_changed !== cmp.session.changed) {
                                // 변경됨
                                // 변경작업 실행
                                cmp.changedJob(cmp.session.changed);
                                
                            } else {
                                // 변경안됨
                                //3초뒤 재호출처리
                                setTimeout(cmp.loadSession, session_refresh_timeout);
                            }

                        }

                    }
                };

                // ajax 실행
                $.app.ajax.module.background(opts);  
            },

            /**
             * 변경이 발생했을때, 처리해줘야할 작업을 기술
             * 
             */
            changedJob: function (changed) {
                // 리스트 갱신
                this.refreshList(changed);               

            },

            /**
             * 현재 이 컴포넌트의 세션정보가 맞는지 검증
             * @return bool
             */
            validateSession: function (response_session) {
                // 리소스 정보가 일치해야함.
                //console.log(response_session);
                if (this.type === response_session.f_type
                    && this.tempId === response_session.f_temp_id
                    && this.cmId === response_session.f_cm_id
                    && this.prodId === response_session.f_prod_id
                    && this.userId === response_session.f_user_id
                    && this.returnId === response_session.f_return_id
                ) {
                    return true;
                }
                return false;
            },

            /**
             * prodId 반환
             * @return int
             */
            getProdId() {
                return this.prodId;
            },

            /**
             * 파일추가 시작
             */
            startAddLocal() {
                this.openUploadArea = true;
            },

            /**
             * Url추가 시작
             */
            startAddUrl() {
                this.openAddUrlArea = true;
            },

            /**
             * 웹캠촬영 시작
             */
            startWebcam() {
                this.openWebcamArea = true;
                this.webcamUploadedDataurls = [];

                UIkit.util.once(this.$refs.modalWebcam, 'shown', () => {

                    // todo : 여기서 설정하는 width 정확히 무슨의민지 모르겠음. 나중에 알아보는게 좋을듯
                    this.webcam.width = this.settings.webcamWidth; // We will scale the photo width to this
                    this.webcam.height = 0; // This will be computed based on the input stream

                    // |streaming| indicates whether or not we're currently streaming
                    // video from the camera. Obviously, we start at false.

                    this.webcam.streaming = false;

                    let video = this.$refs.video;
                    let canvas = this.$refs.canvas;


                    // 촬영시작
                    navigator.mediaDevices
                        .getUserMedia({ video: true, audio: false })
                        .then((stream) => {
                            //console.log(stream);
                            video.srcObject = stream;
                            video.play();
                        })
                        .catch((err) => {
                            console.error(`An error occurred: ${err}`);
                        });


                    video.addEventListener(
                        "canplay",
                        (ev) => {
                            if (! this.webcam.streaming) {
                                this.webcam.height = video.videoHeight / (video.videoWidth / this.webcam.width);

                                // Firefox currently has a bug where the height can't be read from
                                // the video, so we will make assumptions if this happens.

                                if (isNaN(this.webcam.height)) {
                                    this.webcam.height = this.webcam.width / (4 / 3);
                                }

                                video.setAttribute("width", this.webcam.width);
                                video.setAttribute("height", this.webcam.height);
                                canvas.setAttribute("width", this.webcam.width);
                                canvas.setAttribute("height", this.webcam.height);
                                this.webcam.streaming = true;

                                console.log("width : " + this.webcam.width);
                                console.log("height : " + this.webcam.height);
                            }
                        },
                        false
                    );

                });
                UIkit.modal(this.$refs.modalWebcam).show();
            },

            /**
             * 웹캠촬영 종료
             */
            endWebcam() {
                // 웹캠 스트림 종료
                let stream = this.$refs.video.srcObject;

                stream.getTracks().forEach(function(track) {
                    track.stop();
                });

                this.openWebcamArea = false;
                UIkit.util.once(this.$refs.modalWebcam, 'hidden', () => {
                });
                UIkit.modal(this.$refs.modalWebcam).hide();

            },

            /**
             * 웹캠화면 사진찍기
             * - 현재 웹캠화면을 업로드처리
             */
            takeWebcam() {
                const video = this.$refs.video;
                const canvas = this.$refs.canvas;
                const context = canvas.getContext("2d");
                if (this.webcam.width && this.webcam.height) {
                    this.webcamIsUploading = true;
                    canvas.width = this.webcam.width;
                    canvas.height = this.webcam.height;
                    context.drawImage(video, 0, 0, this.webcam.width, this.webcam.height);

                    const data = canvas.toDataURL("image/png");
                    //console.log(data);

                    // 파일 오브젝트 생성
                    let blob = this.dataURLtoBlob(data);
                    //console.log(blob);

                    // 파일명
                    const now = moment();
                    let filename = now.format('YYYMMDDHHmmss');
                    if (this.prodId) {
                        filename += '-' + this.prodId;
                    }
                    filename += '-' + this.webcamUploadedDataurls.length + '.png';

                    let file = new File([blob], filename, {
                        type: blob.type,
                    });

                    // S3업로드
                    let promise = this.s3Upload([file]);

                    promise.then(() => {
                        this.webcamUploadedDataurls.push(data);
                    }).finally(() => {
                        this.webcamIsUploading = false;
                    });

                    /*
                    // 다운로드
                    const path = window.URL.createObjectURL(file)
                    const link = document.createElement('a')
                    link.href = path
                    link.download = "timo-test.png"
                    link.click()
                    link.remove() // IE 미지원
                    */

                } else {
                    // clear 처리
                    //context.fillStyle = "#AAA";
                    //context.fillRect(0, 0, canvas.width, canvas.height);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    // 컴포넌트 헤더
    .component-header {
        border-bottom: 1px solid #999;
        margin-bottom: 10px;
    }

    // 리스트 영역
    .uploaded-items{
        padding: 20px;
        background-color: #fff;
        border: 1px solid #999;
    }

    // 업로드 아이템
    .uploaded-item {
        width: 9rem;
        //margin-right: 1.5rem;
        margin: 1.5rem;
        text-align: center;
        position: relative;

        // 파일 썸네일
        .thumb {
            // 이미지
            .img-file {
                object-fit: contain; 
                width: 8rem;
                height: 8rem;
            }
            // 기타파일
            .etc-file {
                font-size: 8rem;
            }
        }

        // 파일정보
        .file-info {
            opacity: 0;
            position: absolute;
            top: 0.75rem;
            left: 0;
            width: 9rem;
            height: 7rem;
            background-color: #000;
            color: #eaeaea;

            .size, .uploaded_by, .created_at {
                padding: 3px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis; 
            }
        }

        // 파일명
        .file-name {
            
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis; 

        }


        // 삭제
        .remove-btn {
            opacity: 0;
            position: absolute;
            top: -1rem;
            right: -1rem;
            z-index: 30;

            i.material-icons {
                cursor: pointer;
                font-size: 2rem;
                color: #999;
            }

            &:hover {
                i.material-icons {
                    //font-size: 2rem;
                    color: #f0506e;
                }
            }
        }

        // 바로보기
        .view-btn {
            opacity: 0;
            position: absolute;
            bottom: -2.25rem;
            left: 1rem;
            z-index: 30;

            i.material-icons {
                font-size: 2rem;
                cursor: pointer;
                color: #333;
            }

            &:hover {
                i.material-icons {
                    color: #1e87f0;
                }
            }
        }

        // 다운
        .down-btn {
            opacity: 0;
            position: absolute;
            bottom: -2.25rem;
            right: 1rem;
            z-index: 30;
            
            i.material-icons {
                font-size: 2rem;
                cursor: pointer;
                color: #333;
            }

            &:hover {
                i.material-icons {
                    color: #1e87f0;
                }
            }
        }

        // 마우스오버
        &:hover {
            .file-info {
                opacity: 0.8;
            }
            .remove-btn {
                opacity: 1;
            }
            .view-btn {
                opacity: 1;
            }
            .down-btn {
                opacity: 1;
            }
        }

        
    }

    // 스마트폰 촬영중 안내영역
    .opened-session {
        background-color: #fff;
        border: 1px solid #1e87f0;
        text-align: center;
        padding: 20px;
        margin-bottom: 10px;
        position: relative;

        .title-msg {
            color: #999;
            font-size: 1.5rem;
        }
        .sub-msg {
            color: #999;
            font-size: 1rem;
            margin-bottom: 10px;
        }
        .session-code {
            color: #1e87f0;
            //border: 1px solid #000;
            padding: 0.5rem;
            font-size: 2rem;
            font-weight: bold;
        }
    }


    // 전체 영역
    .area {
        // 폰촬영 영역
        .opened-session {
            width: 250px;
        }

        // 업로드 영역
        .upload-area, .add-url-area {
            width: 250px;
        }

        // 업로드 리스트 영역
        .uploaded-area {
            width: 1px;
            -ms-flex: 1;
            flex: 1;
            min-width: 0;
            -ms-flex-preferred-size: 1px;
            flex-basis: 1px;
        }
    }
    .vertical-layout {
        .area {
            // 폰촬영 영역
            .opened-session {
                width: 100%;
            }

            // 업로드 영역
            .upload-area, .add-url-area {
                width: 100%;
            }

            // 업로드 리스트 영역
            .uploaded-area {
                width: 100%;
            }
        }
    }

    // s3업로드 클릭영역
    .s3-upload-clickable {
        border: 2px dashed #0087F7;
        border-radius: 5px;
        background: white;
        margin-bottom: 5px;

        font-size: 1.5rem;
        color: #aaa;
        text-align: center;
        padding: 2em;

        cursor: pointer;
        position: relative;

        i.material-icons {
            font-size: 3rem;
        }

        .s3-dnd-msg {
            position: absolute;
            left: 0;
            top: 0;
            background-color: #0f7ae5;
            //opacity: 0.9;
            width: 100%;
            height: 100%;
            min-height: 200px;
            color: #fff;
            display: none;

            &.dragged {
                display: block;
            }
        }
    }

    .s3-file-input {
        display: none;
    }

    // 웹캠화면
    .webcam-screen {
        background-color: #333;
        video {
            //border: 1px solid black;
            //box-shadow: 2px 2px 3px black;
            width: 100%;
            height: 100%;
        }

        canvas {
            display: none;
        }
    }

    // 웹캠 컨트롤러
    .webcam-controller {
        border-left: 1px solid #666;

        // 촬영버튼
        .btn-take {
            width: 100%;
            height: 14rem;
        }

        // 닫기버튼
        .btn-close {
            width: 100%;
            height: 10rem;
        }

        // 업로드이미지 영역
        .uploaded-images {
            img {
                width: 120px;
                margin: 4px;
                border: 1px solid #999;

                vertical-align: top;
            }

            .uploading {
                display: inline-block;
                width: 120px;
                height: 120px;
                margin: 4px;
                border: 1px solid #999;
                font-size: 1.25rem;

                text-align: center;
                vertical-align: top;

                .loading {
                    font-size: 3rem;
                }
            }
        }
    }

</style>